<template>
	<div class="us">
		<div v-html="records.detail"></div>
	</div>
</template>

<script>
import api from "@/api";
import {listSearchMixin} from '../../config/mixin'

export default {
	mixins:[listSearchMixin],
	data() {
		return {
			type: '',
			records: {}
		}
	},
	created() {
		this.type = this.$route.query.type
		this.getRecords()
	},
	methods:{
		getRecords(){
			let params = {
			  url: api.records + '?type='+this.type,
			  method: 'get',
			  data: {
			  }
			}
			this.sendReq(params, (res) => {
			  if(res.success){
				  this.records = res.data
			  }
			})
		}
	}
}
</script>

<style>
	.us{
		width: 1250px;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/views/us/collaborate.vue